module.exports = __webpack_public_path__ + "static/img/app.07038406.png";